export default {
  title: 'Kontakt & Synchronisation',
  labels: {
    occ_phone_number: 'Telefonnummer des Callcenters',
    company_phone_number: 'Telefonnummer des Restaurants',
    has_google_business_sync: 'Synchronisieren mit Google Business',
    has_foodamigos_sync: 'Synchronisieren mit Fooodamigos Diensten',
  },
  placeholders: {
    occ_phone_number: 'Wählen Sie die Telefonnummer aus der Liste aus.',
  },
};
